/** Questions FAQ pour l'UI et le schema FAQPage (i18n). */
const FAQ_COUNT = 8;

export function getFaqItems(t) {
  return Array.from({ length: FAQ_COUNT }, (_, i) => {
    const n = i + 1;
    const lead = t(`faq.l${n}`);
    const detail = t(`faq.a${n}`);
    return {
      q: t(`faq.q${n}`),
      lead,
      detail,
      a: lead && detail && lead !== `faq.l${n}` ? `${lead} ${detail}` : detail,
    };
  });
}

export default getFaqItems;
